import { Directive, TemplateRef } from '@angular/core';

interface Context<T> {
  $implicit?: T; // current item exposed as implicit value
  index?: number;
}

@Directive({
  selector: '[appRowHeaders]',
  standalone: false,
})
export class RowHeadersDirective {
  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public templateRef: TemplateRef<any>,
  ) {}

  static ngTemplateContextGuard<T>(
    dir: RowHeadersDirective,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ctx: any,
  ): ctx is Context<T> {
    return true;
  }
}
